import type { TabsProps } from '@mui/material/Tabs';
import { useCallback, useId } from 'react';

type UseMetricTabsOptions = {
  onChange: (value: string) => void;
};

export const useMetricTabs = ({ onChange }: UseMetricTabsOptions) => {
  const componentId = useId();
  const getTabId = useCallback((tabId: string) => `${componentId}-tab-${tabId}`, [componentId]);
  const getPanelId = useCallback((tabId: string) => `${componentId}-panel-${tabId}`, [componentId]);
  const handleChange = useCallback<NonNullable<TabsProps['onChange']>>(
    (_event, selectedValue) => onChange(selectedValue),
    [onChange]
  );

  return { getTabId, getPanelId, handleChange };
};
